/**
 * LearnSkill use case: increment one skill level if canLearn passes.
 */

import type { MageProfile } from "../../domain/mage-profile.js";
import { tryLearnSkill, tryRefundSkill } from "../../domain/mage-profile.js";
import { levelFromXp } from "../../domain/mage-xp.js";
import type { RenderPort, GameStateView } from "../ports.js";

export interface LearnSkillDeps {
  getMageProfile: () => MageProfile;
  saveMageProfile: () => Promise<void>;
  render: RenderPort;
  getMapView: () => GameStateView;
}

export function createLearnSkill(deps: LearnSkillDeps) {
  return async function learnSkill(skillId: number, options?: { all?: boolean }): Promise<boolean> {
    const profile = deps.getMageProfile();
    const mageLevel = levelFromXp(profile.totalXp);
    let changed = false;
    do {
      const ok = tryLearnSkill(profile, skillId, mageLevel);
      changed ||= ok;
      if (!ok) break;
    } while (options?.all);
    if (changed) {
      await deps.saveMageProfile();
      deps.render.update(deps.getMapView());
    }
    return changed;
  };
}

export function createRefundSkill(deps: LearnSkillDeps) {
  return async function refundSkill(skillId: number, options?: { all?: boolean }): Promise<boolean> {
    const profile = deps.getMageProfile();
    let changed = false;
    do {
      const ok = tryRefundSkill(profile, skillId);
      changed ||= ok;
      if (!ok) break;
    } while (options?.all);
    if (changed) {
      await deps.saveMageProfile();
      deps.render.update(deps.getMapView());
    }
    return changed;
  };
}
